import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isObject from 'lodash/isObject';

import MovableByMouse from '@Hooks/MovableByMouse';

const savedCoordinatesMap = {};

export function movableMouseToStyle(newRefCoordinates, saveCoordinatesKey) {
  const coordinates = newRefCoordinates
    ? (({ x, y }) => ({ x, y }))(newRefCoordinates)
    : saveCoordinatesKey && savedCoordinatesMap[saveCoordinatesKey];

  if (saveCoordinatesKey && coordinates) {
    savedCoordinatesMap[saveCoordinatesKey] = coordinates;
  }

  return isObject(coordinates)
    ? {
        top: `${coordinates.y}px`,
        left: `${coordinates.x}px`,
        transform: 'initial',
        transition: 'none',
      }
    : undefined;
}

export const createMousedownEventValidator = (baseDialogLayoutAllowed) => {
  return (e) => {
    const { target } = e;
    const baseLayoutHeaderClicked = Boolean(target.closest('.base-dialog-layout-header-wrapper'));

    if (baseLayoutHeaderClicked) {
      return true;
    }

    return baseDialogLayoutAllowed && target.classList.contains('base-dialog-layout');
  };
};

export default function BaseDialogLayoutMovableHoc(Component) {
  function BaseDialogLayoutMovableHocWrapper(props) {
    const { id, movable, resizable, movableSaveCoordinates } = props;

    const validateMousedownEvent = useMemo(() => createMousedownEventValidator(!resizable), [resizable]);

    if (!movable) {
      return <Component {...props} />;
    }

    return (
      <MovableByMouse validateMousedownEvent={validateMousedownEvent}>
        {(refForMovable, movableMouse, newRefCoordinates) => {
          const style = movableMouseToStyle(newRefCoordinates, movableSaveCoordinates && id);
          const { className, ...otherProps } = props;
          return (
            <Component {...otherProps} ref={refForMovable} className={classnames(className, 'base-dialog-layout-movable')} style={style} />
          );
        }}
      </MovableByMouse>
    );
  }

  BaseDialogLayoutMovableHocWrapper.defaultProps = {
    movable: true,
    resizable: false,
  };

  BaseDialogLayoutMovableHocWrapper.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    movable: PropTypes.bool,
    resizable: PropTypes.bool,
    movableSaveCoordinates: PropTypes.bool,
  };

  return BaseDialogLayoutMovableHocWrapper;
}
